import gql from 'graphql-tag';

export const CREATE_GLOBAL_ARI = gql`
mutation ($input: CreateGlobalAriFieldsInput!) {
    createGlobalAriFields(input: $input) {
        account {
            id
        }
    }
}
`;

export const CREATE_LOCAL_ARI = gql`
mutation ($input: CreateLocalAriFieldsInput!) {
    createLocalAriFields(input: $input) {
        account {
            id
        }
    }
}
`;

export const UPDATE_GLOBAL_ARI = gql`
mutation ($input: SetGlobalAriFieldInput!) {
    updateGlobalAriField(input: $input) {
        account {
            id
        }
    }
}
`;

export const UPDATE_LOCAL_ARI = gql`
mutation ($input: UpdateLocalAriFieldInput!) {
    updateLocalAriField(input: $input) {
        account {
            id
        }
    }
}
`;

export const DELETE_GLOBAL_ARI = gql`
mutation ($input: DeleteAriFieldInput!) {
    deleteGlobalAriField(input: $input) {
        account {
            id
        }
    }
}
`;

export const DELETE_LOCAL_ARI = gql`
mutation ($input: DeleteAriFieldInput!) {
    deleteLocalAriField(input: $input) {
        account {
            id
        }
    }
}
`;

export const TOGGLE_ALLOW_LOCAL_FIELDS = gql`
mutation ($input: ToggleAllowAriFieldsInput!) {
    toggleAllowLocalAriFields(input: $input) {
        account {
            id
        }
    }
}
`;

export const TOGGLE_ALLOW_GLOBAL_FIELDS_SELF_REGISTRATION = gql`
mutation ($input: ToggleAriFieldsForSuperLinksInput!) {
    toggleGlobalAriFieldsForSuperLinks(input: $input) {
        account {
            id
        }
    }
}
`;

export const TOGGLE_ALLOW_LOCAL_FIELDS_SELF_REGISTRATION = gql`
mutation ($input: ToggleAriFieldsForSuperLinksInput!) {
    toggleLocalAriFieldsForSuperLinks(input: $input) {
        account {
            id
        }
    }
}
`;

export const TOGGLE_ALLOW_GLOBAL_FIELDS_QUESTIONNAIRE = gql`
mutation ($input: ToggleAriFieldsForQuestionnairesInput!) {
    toggleGlobalAriFieldsForQuestionnaires(input: $input) {
        account {
            id
        }
    }
}
`;

export const TOGGLE_ALLOW_LOCAL_FIELDS_QUESTIONNAIRE = gql`
mutation ($input: ToggleAriFieldsForQuestionnairesInput!) {
    toggleLocalAriFieldsForQuestionnaires(input: $input) {
        account {
            id
        }
    }
}
`;

export const ACCEPT_GDPR_FOR_ACCOUNT = gql`
mutation ($id: ID!) {
    acceptGdprTermsForAccount(accountId: $id) {
        userId,
        accountId,
        acceptedOn
    }
}
`;

export const UPDATE_GLOBAL_ARI_RANK = gql`
mutation ($input: ChangeAriFieldRankInput!) {
    changeGlobalAriFieldRank(input: $input) {
        account {
            id
        }
    }
}
`;

export const UPDATE_LOCAL_ARI_RANK = gql`
mutation ($input: ChangeAriFieldRankInput!) {
    changeLocalAriFieldRank(input: $input) {
        account {
            id
        }
    }
}
`;
